import { user_addresses } from "@core/gql-mockups/addresses";
import { deputations, shipping_center } from "@core/gql-mockups/deputations";

const { minimize_str } = require("@core/helpers/string");

export const GET_USER_ADDRESSES_AND_SHIPPING_METHODS_AND_PAYMENT_METHODS =
  minimize_str(`
  query ($filter:AddressFilter, $address_id: ID, $lang: String = "fa") {
  user_addresses: getAllUserAddresses(filter:$filter) ${user_addresses}
  shipping_methods: getUserShippingMethods (lang: $lang, address_id: $address_id) {
    id
    title
    description
    price
    is_default
  }
  payment_methods: getUserPaymentGateways {
    id
    title
    gateway
    extra_fields
  }
}
`);

export const GET_USER_PAYMENT_METHODS =
  minimize_str(`
  query {
  result: getUserPaymentGateways {
    id
    title
    gateway
    extra_fields
    is_installment
    commission_percent
  }
}
`);

export const GET_USER_ADDRESSES_AND_SHIPPING_METHODS_AND_PAYMENT_METHODS_AND_DEPUTATIONS =
  minimize_str(`
  query ($filter:AddressFilter, $address_id: ID, $deputation_filters: DeputationFilter, $lang: String = "fa") {
  user_addresses: getAllUserAddresses(filter:$filter) ${user_addresses}
  shipping_methods: getUserShippingMethods (lang: $lang, address_id: $address_id) {
    id
    title
    description
    price
    is_default
  }
  payment_methods: getUserPaymentGateways {
    id
    title
    gateway
    extra_fields
  }
  deputations: getAllDeputations(filters: $deputation_filters) ${deputations}
}
`);

export const GET_SHIPPING_METHODS_AND_PAYMENT_METHODS_AND_DEPUTATIONS =
  minimize_str(`
  query {
 
  payment_methods: getUserPaymentGateways {
    id
    title
    gateway
    extra_fields
    is_installment
    commission_percent
  }
  deputations: getUserShippingCenters ${shipping_center}
}
`);

export const GET_SHIPPING_METHODS = minimize_str(`
   query ($address_id: ID, $lang: String = "fa") {
  result: getUserShippingMethods (lang: $lang, address_id: $address_id) {
    id
    title
    description
    price
    is_default
    price_after_delivery
    base_price
    }
  }
`);

export const GET_DEPUTATIONS = minimize_str(`
  query ($deputation_filters: DeputationFilter) {
    deputations: getAllDeputations(filters: $deputation_filters) ${deputations}
  }
`);

export const GET_USER_WALLET = minimize_str(`
  query ($lang: String) {
    result: getUserWallet(lang:$lang) {
      sum_money_ballance
    }
  }
`);

export const GET_USER_WALLET_TRANSACTIONS = minimize_str(`
  query ($page: Int, $limit: Int, $filter: WalletTransactionFilter, $sort: WalletTransactionSort) {
    result: getUserWalletTransactions(page: $page, limit: $limit, filter: $filter, sort: $sort) {
      paginate {
        total
        limit
        page
        pages
        hasPrevPage
        hasNextPage
      }
      data {
        id
        type
        amount
        real_money_ballance
        gift_money_ballance
        parsed_note
        transaction_id
        order_id
        wallet_id
        createdAt
        updatedAt
        order {
          id
          number
        }
        transaction {
          id
          gateway
          track_code
        }
      }
    }
  }
`);

// a debt sent to the customer as a link (`/debt-payment/?debt_id=`): what to show before paying it (useDebtPayment)
export const GET_DEBT = minimize_str(`
  query ($debt_id: ID) {
    result: getDebt(debt_id: $debt_id) {
      title
      amount
      expireAt
      user_full_name
    }
  }
`);
